module.exports = __webpack_public_path__ + "img/1544185972.581980fb.jpg";